import axios from "axios";

const store = {
    state: {

    },

    getters: {

    },

    mutations: {

    },

    actions: {
        storeRentAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/rent/store`, payload)
                    .then(() => {
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        updateRentAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/rent/update/${payload.get("rent_id")}`, payload)
                    .then((res) => {
                        resolve(res.data.rent);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        deletePhotoRentAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/rent/delete-photo`, payload)
                    .then(() => {
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        findRentalsAction() {
            return new Promise((resolve, reject) => {
                axios.get(`/rent/find-all`).then((res) => {
                    resolve(res.data);
                }).catch((err) => {
                    reject(err);
                })
            })
        },

        deleteRentAction(Context, rentId) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/rent/delete-rent/${rentId}`)
                    .then(() => {
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        amountRentalsAction() {
            return new Promise((resolve, reject) => {
              axios
                .get(`/rent/amount`)
                .then((res) => {
                  resolve(res.data);
                })
                .catch((err) => {
                  reject(err);
                });
            });
          },

          totalWeekAction(){
            return new Promise((resolve, reject) => {
              axios
                .get(`/rent/total-week`)
                .then((res) => {
                  resolve(res.data);
                })
                .catch((err) => {
                  reject(err);
                });
            });
          }
      
    },
};

export default store;
